import { analytics, auth, firestore, fieldValue } from "../firebase";

const myfunctions = {};

myfunctions.createUser = (formData) => {
  return new Promise((resolve, reject) => {
    if (!formData) {
      reject(new Error("No hay data"));

      return;
    }

    auth
      .createUserWithEmailAndPassword(
        `${formData.nic}@lospoloatierra.com`,
        `qw12er21${formData.nic}`
      )
      .then((user) => {
        let batch = firestore.batch();
        let ruRef = firestore.collection("registeredUsers").doc(user.user.uid);
        batch.set(ruRef, {
          userId: user.user.uid,
          entryControl: 1,
          timestampRegister: fieldValue.serverTimestamp(),
          ...formData,
          questionsAnswered: 0,
          triviaPunctuation: 0,
          listTriviaPunctuation: [],
          answersIndex: [],
          crossword: false,
          sopaletra: false,
          crosswordPunctuation: 0,
          numberTriviaCorrect: 0,
        });

        batch
          .commit()
          .then((value) => {
            analytics.logEvent("nuevo_registro");
            resolve(value);
          })
          .catch((reason) => {
            console.log(
              "🚀 ~ file: myfunctions.js ~ line 41 ~ .then ~ reason",
              reason
            );
            reject("Ha ocurrido un error, Intenta mas tardee");
          });
      })
      .catch((error) => {
        console.log("🚀 ReturnnewPromise ~ error", error);
        reject("Ha ocurrido un error, Intenta mas tardeee");
      });
  });
};

myfunctions.loginUser = (formData) => {
  return new Promise((resolve, reject) => {
    if (!formData) {
      reject(new Error("No hay data"));

      return;
    }
    auth
      .signInWithEmailAndPassword(
        `${formData.nic}@lospoloatierra.com`,
        `qw12er21${formData.nic}`
      )
      .then((user) => {
        let batch = firestore.batch();
        let ruRef = firestore.collection("registeredUsers").doc(user.user.uid);
        batch.update(ruRef, {
          entryControl: fieldValue.increment(1),
          timestampLogin: fieldValue.serverTimestamp(),
        });
        batch
          .commit()
          .then((value) => {
            analytics.logEvent("inicio_usuario");
            resolve(value);
          })
          .catch((reason) => {
            reject("Ha ocurrido un error al ingresar, Intenta mas tarde");
          });
      })
      .catch((error) => {
        console.log("🚀 ReturnnewPromise ~ error", error);
        reject("Ha ocurrido un error al ingresar, Intenta mas tarde");
      });
  });
};

myfunctions.logout = () => {
  return new Promise((resolve, reject) => {
    auth
      .signOut()
      .then(() => {
        localStorage.clear();
        window.location.reload();
        resolve("Desconectado");
      })
      .catch((error) => {
        reject(
          new Error("Ha ocurrido un error al cerrar sesión. Intenta mas tarde.")
        );
      });
  });
};
myfunctions.updateTrivia = (userId, questionsAnswered, points) => {
  return new Promise((resolve, reject) => {
    var query = firestore.collection("registeredUsers").doc(userId);

    return query
      .update({
        listTriviaPunctuation: fieldValue.arrayUnion({
          questionsAnswered: questionsAnswered,
          points: points,
        }),
        numberTriviaCorrect:
          points === 100 ? fieldValue.increment(1) : fieldValue.increment(0),
        triviaPunctuation: fieldValue.increment(points),
        updateTrivia: fieldValue.serverTimestamp(),
        questionsAnswered: fieldValue.increment(1),
      })
      .then(() => {
        console.log("Documento actualizado correctamente!");
        resolve("Actualizado");
      })
      .catch((error) => {
        reject(new Error("Error al actualizar", error));
      });
  });
};

myfunctions.updateCrucigrama = (userId, points) => {
  return new Promise((resolve, reject) => {
    var query = firestore.collection("registeredUsers").doc(userId);

    return query
      .update({
        crossword: true,
        crosswordPunctuation: points,
      })
      .then(() => {
        console.log("Documento actualizado correctamente!");
        resolve("Actualizado");
      })
      .catch((error) => {
        reject(new Error("Error al actualizar", error));
      });
  });
};

myfunctions.updateSopaLetras = (userId) => {
  return new Promise((resolve, reject) => {
    var query = firestore.collection("registeredUsers").doc(userId);

    return query
      .update({
        sopaletra: true,
      })
      .then(() => {
        console.log("Documento actualizado correctamente!");
        resolve("Actualizado");
      })
      .catch((error) => {
        reject(new Error("Error al actualizar", error));
      });
  });
};

export default myfunctions;
